import { CarouselContainer } from '../CarouselContainer';
import { FeatureLabelsContainer } from '../FeatureLabelsContainer';
import { ThumbnailsContainer } from '../ThumbnailsContainer';

export function GalleryContainer() {
  return (
    <>
      <CarouselContainer />
      <ThumbnailsContainer />
      <FeatureLabelsContainer />
    </>
  );
}
